import React, { useEffect, useRef, useState } from "react";
import usePageState from '../Custom_Hooks/usePageState';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import { currentPeriodRedux } from "../../redux/actions/action-creator";
import { getValidPeriodDate, dateFormateSend } from '../Date_Formate_Utilitiy/Index';

function Period_Home(props) {
    const { userData = null } = useSelector(state => state.auth);
    const { company_session } = useSelector((state) => state.common);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [date, setdate] = usePageState('period_home_form', { from: '', to: '', show_date: '' })
    const from_input_ref = useRef(null)
    const to_input_ref = useRef(null)
    const initialRender = useRef(true);

    useEffect(() => {
        if (initialRender.current && company_session) {
            let updates = {};
            if (!date.from && company_session.start_financial_year) {
                updates.from = new Date(company_session.start_financial_year).toLocaleDateString('en-GB').replace(/\//g, '.');
            }
            if (!date.to && company_session.end_financial_year) {
                updates.to = new Date(company_session.end_financial_year).toLocaleDateString('en-GB').replace(/\//g, '.');
            }
            if (Object.keys(updates).length > 0) {
                setdate(prev => ({ ...prev, ...updates }));
            }
            initialRender.current = false;

            setTimeout(() => {
                if (from_input_ref.current) {
                    from_input_ref.current.focus();
                    from_input_ref.current.select();
                }
            }, 100);
        }
    }, [company_session, setdate]);

    const handlechange = (e) => {
        const { name, value } = e?.target;
        setdate((prevDate) => ({ ...prevDate, [name]: value }));
    }

    const onKeyDown = (e) => {
        const { name, value } = e?.target;
        if (name === 'from' && e?.key === 'Enter') {
            e?.preventDefault();
            let inputValue = value.trim();
            if (inputValue === '') {
                if (company_session?.start_financial_year) {
                    inputValue = new Date(company_session.start_financial_year).toLocaleDateString('en-GB').replace(/\//g, '.');
                }
            }
            if (inputValue !== '') {
                const parsedDate = getValidPeriodDate(inputValue, company_session);
                if (parsedDate) {
                    const formattedDateString_send = dateFormateSend(parsedDate.formattedDateString);
                    setdate({ ...date, from: parsedDate.formattedDateString, show_date: formattedDateString_send })
                    to_input_ref.current.focus();
                    to_input_ref.current.select();
                } else {
                    alert("Invalid date");
                }
            }
        }
        if (name === 'to' && e?.key === 'Enter') {
            e?.preventDefault();
            let inputValue = value.trim();
            if (inputValue === '') {
                if (company_session?.end_financial_year) {
                    inputValue = new Date(company_session.end_financial_year).toLocaleDateString('en-GB').replace(/\//g, '.');
                }
            }
            if (inputValue !== '') {
                const from_date_check = new Date(date?.show_date);
                const from_date_year = from_date_check.getFullYear();

                const books_being_date = new Date(userData?.books_being_date);
                const books_being_year = books_being_date.getFullYear();
                if (books_being_year <= from_date_year) {
                    const parsedDate = getValidPeriodDate(inputValue, company_session, date.from);
                    if (parsedDate) {
                        const formattedDateString_send = dateFormateSend(parsedDate.formattedDateString);
                        const date_validate = new Date(formattedDateString_send);
                        const date_validate_from = new Date(date?.from);
                        const day_show = parsedDate.day_show;
                        const day_show_from = date_validate_from?.toLocaleString('en-US', { weekday: 'long' });

                        const currentDate = new Date();
                        const currentMonth = currentDate.getMonth() + 1;
                        const currentYear = currentDate.getFullYear();
                        const financialYearStartYear = currentMonth < 4 ? currentYear - 1 : currentYear;
                        const financialYearEndYear = financialYearStartYear + 1;
                        const current_date_get =
                            date_validate_from.getFullYear() <= financialYearStartYear ?
                                date_validate.getFullYear() >= financialYearEndYear ?
                                    `${day_show_from},${date?.from}` :
                                    `${day_show},${parsedDate.formattedDateString}` :
                                `${day_show_from},${date?.from}`;

                        if (from_date_check <= date_validate) {
                            dispatch(currentPeriodRedux(
                                {
                                    financl_year: `${date.from} To ${parsedDate.formattedDateString}`,
                                    start_fincl_year: date.from,
                                    end_fincl_year: parsedDate.formattedDateString,
                                    cur_date: current_date_get
                                }))
                            navigate('/')
                        } else {
                            alert('Invalid Date')
                        }
                    } else {
                        alert('Invalid date');
                    }
                } else {
                    alert("Books Beginning From " + books_being_year + ". Please do not select a period earlier than " + books_being_year + ".");
                }
            }
        }
    }

    useEffect(() => {
        const handlekeydown = (e) => {
            if (e?.key === 'Escape') {
                e?.preventDefault();
                navigate('/')
                e?.stopPropagation();
            }
        }
        document.addEventListener('keydown', handlekeydown)
        return () => {
            document.removeEventListener('keydown', handlekeydown);
        };
    }, [props?.data, date])
    const { from, to } = date;

    return (
        <div className='my-card'>
            <div className='cross_button' onClick={() => { navigate('/') }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
            </div>
            <div className='container pb-3' id='card-period'>
                <div className='row'>
                    <div className='col'>
                        <b className='border-bottom'>Current Period</b>
                    </div>
                </div>
                <div className='row'>
                    <form autoComplete='off' onSubmit={(e) => e.preventDefault()}>
                        <div className='col'>
                            <div className='d-flex justify-content-between align-item-center'>
                                <label className='lab-1'>From</label>
                                <label>:</label>
                                <input type='text' name='from' id='from' ref={from_input_ref} onChange={handlechange} onKeyDown={onKeyDown} value={from} className='lab-right' />
                            </div>
                            <div className='d-flex justify-content-between align-item-center'>
                                <label className='lab-1'>To</label>
                                <label>:</label>
                                <input type='text' name='to' id='to' ref={to_input_ref} onChange={handlechange} onKeyDown={onKeyDown} value={to} className='lab-right' />
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className='tomasterfooter' style={{ background: 'red' }}><Footer /></div>
        </div>
    )
}
export default Period_Home;